import {Heading, Text, useDevice} from 'platform/foundation';

import i18n from '@dms/i18n';

import {DocumentExtractionImportCloudImage} from './DocumentExtractionImportCloudImage';

export function DocumentExtractionImportHeader() {
  const device = useDevice();

  const isMobile = device === 'mobile';

  return (
    <>
      <DocumentExtractionImportCloudImage />
      <Heading size={isMobile ? 4 : 2} align="center">
        {i18n.t('entity.documentExtraction.labels.chooseTypeAndImportFile')}
      </Heading>
      <Text size={isMobile ? 'xSmall' : 'small'} align="center" color="secondary">
        {i18n.t('entity.documentExtraction.labels.uploadExternalDataInstruction')}
      </Text>
    </>
  );
}
